<template>
<div class="chapter">
<div class="inner_page">
<div id="a04_toc">
<a id="page_5">
<p class="toctitle">CONTENTS</p>
</a><p class="toc1"><a id="page_5"></a><a href="#/09_prf1"><b>PREFACE</b> <i>Romain Cansiere</i></a></p>
<p class="toc1"><a href="#/10_prf2"><b>PREFACE</b> <i>Ed Gilbert</i></a></p>
<p class="toc1"><a href="#/11_fore"><b>FOREWORD</b> <i>Edward L. Bale, Jr., Colonel, USMC (Ret)</i></a></p>
<p class="toc"><a href="#/12_ch01">1 <span class="spacert"><b>A NEW DOCTRINE FOR A NEW WAR</b></span></a></p>
<p class="toc"><a href="#/13_ch02">2 <span class="spacert"><b>SALAD DAYS—FORMATION AND TRAINING</b></span></a></p>
<p class="toc"><span href="#/14_ch03" title="Link target outside of Sample">3 <span class="spacert"><b>THE TANKS OF CHARLIE COMPANY</b></span></span></p>
<p class="toc"><span href="#/15_ch04" title="Link target outside of Sample">4 <span class="spacert"><b>THE CLOTHES ON THEIR BACKS—CLOTHING AND EQUIPMENT</b></span></span></p>
<p class="toc"><span href="#/16_ch05" title="Link target outside of Sample">5 <span class="spacert"><b>OBJECTIVE: CODE NAME HELEN</b></span></span></p>
<p class="toc"><span href="#/17_ch06" title="Link target outside of Sample">6 <span class="spacert"><b>DAY ONE—THE REEF</b></span></span></p>
<p class="toc"><span href="#/18_ch07" title="Link target outside of Sample">7 <span class="spacert"><b>DAY ONE—INLAND</b></span></span></p>
<p class="toc"><span href="#/19_ch08" title="Link target outside of Sample">8 <span class="spacert"><b>DAY TWO—SECURING THE BEACHHEAD</b></span></span></p>
<p class="toc"><span href="#/20_ch09" title="Link target outside of Sample">9 <span class="spacert"><b>DAY THREE—SWEEPING THE ISLAND</b></span></span></p>
<p class="toca"><span href="#/21_ch10" title="Link target outside of Sample">10 <span class="spacert"><b>DAY FOUR—THE FINAL CARNAGE</b></span></span></p>
<p class="toca"><span href="#/21_ch11" title="Link target outside of Sample">11 <span class="spacert"><b>AFTERMATH</b></span></span></p>
<p class="toc1"><span href="#/22_epi" title="Link target outside of Sample"><b>EPILOGUE:</b> <i>The Legacy of Tarawa</i></span></p>
<p class="toc1"><span href="#/23_later" title="Link target outside of Sample"><b>LATER LIFE</b></span></p>
<p class="toc1"><span href="#/24_appA" title="Link target outside of Sample"><b>APPENDIX A:</b> <i>Charlie Company Chronology</i></span></p>
<p class="toc1"><span href="#/25_appB" title="Link target outside of Sample"><b>APPENDIX B:</b> <i>Tank Company Organization and Equipment</i></span></p>
<p class="toc1"><span href="#/26_appC" title="Link target outside of Sample"><b>APPENDIX C:</b> <i>Inside the M4A2 Tank</i></span></p>
<p class="toc1"><span href="#/27_appD" title="Link target outside of Sample"><b>APPENDIX D:</b> <i>Charlie Company Personnel at Tarawa</i></span></p>
<p class="toc1"><span href="#/28_appE" title="Link target outside of Sample"><b>APPENDIX E:</b> <i>Historical Research and Photographic Analysis</i></span></p>
<p class="toc1"><span href="#/29_notes" title="Link target outside of Sample"><b>NOTES</b></span></p>
<p class="toc1"><span href="#/30_ref" title="Link target outside of Sample"><b>REFERENCES CITED</b></span></p>
<p class="toc1"><span href="#/06_ack" title="Link target outside of Sample"><b>ACKNOWLEDGMENTS</b></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_toc.vue?3c180b3a